import { Link } from '@tanstack/react-router'
import type { ReactNode } from 'react'

import type { Language } from '@/bindings/Language'
import type { SessionDetails } from '@/bindings/SessionDetails'
import { OrderCard, SessionSheet, type Venue } from '@/features/ordering/order-view'
import { useT } from '@/lib/i18n/translate'

const ORDER_PATH = '/$restaurantSlug/$branchSlug/manage/orders/$orderId'

interface SessionScope {
  restaurantSlug: string
  branchSlug: string
}

/**
 * One session for staff (G11, G14): every order as a card linking to its page (G10, for
 * moves, returns and real weight), the bill with canceled and expired orders struck (G7).
 * On paper an 80 mm thermal ticket under the venue — `.ticket` in `styles.css`.
 */
export function SessionTicket({ details, main, venue, scope }: { details: SessionDetails; main: Language; venue: Venue; scope: SessionScope }) {
  const t = useT()
  const { session, orders, total } = details
  return (
    <SessionSheet heading="h1" session={session} code venue={venue} currency={details.currency} total={total} orders={orders}>
      {(order) => (
        <OrderCard
          order={order}
          currency={order.currency}
          main={main}
          code
          nested
          title={
            <Link
              to={ORDER_PATH}
              params={{ restaurantSlug: scope.restaurantSlug, branchSlug: scope.branchSlug, orderId: order.id }}
              className="text-accent-ink print:text-fg hover:underline"
            >
              {t('track.title', { number: order.number })}
            </Link>
          }
        />
      )}
    </SessionSheet>
  )
}

/** Off-screen, on paper only. */
export function PrintOnly({ children }: { children: ReactNode }) {
  return <div className="hidden print:block">{children}</div>
}
